import Transform from '@ember-data/serializer/transform';
export default class StringEmptyToNull extends Transform {
  deserialize(serialized) {
    return serialized;
  }
  serialize(deserialized) {
    return deserialized || null;
  }
}